import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api, fmtDate, imgUrl } from "@/api";
import { useLang } from "@/i18n";

const CATS = ["", "berita", "karya-ilmiah", "opini", "gagasan", "kalam-masyayikh"];
const CAT_LABEL = { "": "artikel.all", "berita": "artikel.berita", "karya-ilmiah": "artikel.karya", "opini": "artikel.opini", "gagasan": "artikel.gagasan", "kalam-masyayikh": "artikel.kalam" };

export default function ArtikelPage() {
  const { t, lang } = useLang();
  const [cat, setCat] = useState("");
  const [articles, setArticles] = useState([]);

  useEffect(() => {
    api.get("/articles", { params: cat ? { category: cat } : {} }).then((r) => setArticles(r.data)).catch(() => {});
  }, [cat]);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 py-14 sm:py-20" data-testid="artikel-page">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-emerald-950 tracking-tight">{t("artikel.title")}</h1>
        <p className="text-slate-600 mt-3">{t("artikel.subtitle")}</p>
      </motion.div>

      <div className="flex flex-wrap gap-2 mt-8">
        {CATS.map((c) => (
          <button
            key={c}
            onClick={() => setCat(c)}
            data-testid={`artikel-filter-${c || "semua"}`}
            className={`rounded-full px-4 py-1.5 text-sm font-medium transition-colors ${
              cat === c ? "bg-emerald-800 text-white" : "bg-white border border-emerald-900/15 text-slate-600 hover:border-emerald-800 hover:text-emerald-800"
            }`}
          >
            {t(CAT_LABEL[c])}
          </button>
        ))}
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10">
        {articles.map((a, i) => (
          <motion.div key={a.id} initial={{ opacity: 0, y: 24 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: i * 0.06 }}>
            <Link to={`/artikel/${a.id}`} className="group block bg-white rounded-xl border border-emerald-900/10 shadow-sm overflow-hidden h-full" data-testid={`artikel-card-${a.id}`}>
              <div className="aspect-video overflow-hidden bg-emerald-50">
                {a.cover && <img src={imgUrl(a.cover)} alt={a.title} className="h-full w-full object-cover group-hover:scale-105 transition-transform duration-500" />}
              </div>
              <div className="p-6">
                <span className="text-[11px] font-bold uppercase tracking-wider text-emerald-950 bg-[#D4AF37]/25 border border-[#D4AF37]/60 rounded-full px-3 py-0.5">
                  {t(CAT_LABEL[a.category] || a.category)}
                </span>
                <h3 className="font-display text-xl font-bold text-emerald-950 mt-3 group-hover:text-emerald-700 transition-colors leading-snug">{a.title}</h3>
                <p className="text-sm text-slate-600 mt-2 line-clamp-3">{a.excerpt}...</p>
                <p className="text-xs text-slate-400 mt-4">{fmtDate(a.created_at, lang)} · {t("artikel.published_by")} {a.author_name}</p>
              </div>
            </Link>
          </motion.div>
        ))}
      </div>
      {articles.length === 0 && <p className="text-slate-500 mt-10">{t("common.loading")}</p>}
    </div>
  );
}
